import {PriceModel} from '../Price.model';

export class BreakdownModel {
  public comparePrice?: PriceModel;
  public comparePriceByQuantity?: PriceModel;
  public basePrice?: PriceModel;
  public totalModifiersPrice?: PriceModel;

  constructor(params: BreakdownModel) {
    this.comparePrice = params.comparePrice;
    this.comparePriceByQuantity = params.comparePriceByQuantity;
    this.basePrice = params.basePrice;
    this.totalModifiersPrice = params.totalModifiersPrice;
  }

  public static fromCartV1({
    comparePrice,
    comparePriceByQuantity,
    basePrice,
    totalModifiersPrice,
  }: {
    comparePrice?: PriceModel;
    comparePriceByQuantity?: PriceModel;
    basePrice?: PriceModel;
    totalModifiersPrice?: PriceModel;
  }) {
    return new BreakdownModel({
      comparePrice,
      comparePriceByQuantity,
      basePrice,
      totalModifiersPrice,
    });
  }
}
